import { useContext } from 'react';
import { PageMetadataContext } from '../context';

export const useSetTitle = () => {
  const { setTitle } = useContext(PageMetadataContext);
  return setTitle;
};
